module.exports = __webpack_public_path__ + "img/ic_video-off.1a76430d.svg";